/**
 * A check or a cross in an outlined circle.
 *
 * The icon set draws its check circle only filled (`ui:scheduleOn`) and its
 * outlined circle only with a plus (`ui:schedule`), so the outlined states the
 * Saved pill and the phone's swipe label need are drawn here, at the same
 * weight. `currentColor` throughout, like the generated icons.
 */
export default function OutlinedCircle({ mark, size }: { mark: 'check' | 'cross'; size: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      stroke="currentColor"
      aria-hidden
      focusable="false"
      style={{ display: 'block', flexShrink: 0 }}
    >
      <circle cx="9" cy="9" r="8.1" strokeWidth="1.6" />
      {mark === 'check' ? (
        <path d="M5.4 9.3l2.3 2.3 4.9-4.9" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      ) : (
        <path d="M6.3 6.3l5.4 5.4M11.7 6.3l-5.4 5.4" strokeWidth="1.6" strokeLinecap="round" />
      )}
    </svg>
  );
}
